import React from "react";
import { Link } from "react-router-dom";
import { useT } from "../hooks/useLang";

export default function Footer() {
  const t = useT();

  const navLinks = [
    { to: "/", label: t("accueil") },
    { to: "/qui-sommes-nous", label: t("quiSommesNous") },
    { to: "/news", label: t("news") },
    { to: "/contact", label: t("contact") },
  ];

  const legalLinks = [
    { to: "/a-propos", label: t("aPropos") },
    { to: "/cgu", label: t("cgu") },
    { to: "/confidentialite", label: t("confidentialite") },
    { to: "/politique-cookies", label: t("politiqueCookies") },
  ];

  return (
    <footer>
      {/* Bande damier teal / crème */}
      <div style={{
        height: 28,
        backgroundImage: `repeating-conic-gradient(#2a7a6f 0% 25%, #f7f4ee 0% 50%)`,
        backgroundSize: "28px 28px",
        borderTop: "3px solid #0d1117",
        borderBottom: "3px solid #0d1117",
      }} />

      {/* Corps du footer */}
      <div style={{ background: "#1a1a1a", color: "#f7f4ee" }}>
        <div className="max-w-5xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Col 1 — Logo + description */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div style={{
                width: 40, height: 40, borderRadius: "50%",
                border: "3px solid #f5c200",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "1.2rem",
              }}>
                ⚡
              </div>
              <div>
                <div style={{
                  fontFamily: "cursive",
                  fontSize: "1.3rem",
                  color: "#f7f4ee",
                  fontWeight: 700,
                  lineHeight: 1.1,
                }}>
                  Starting Five
                </div>
                <div style={{ fontSize: "0.65rem", color: "#999", letterSpacing: "0.15em", textTransform: "uppercase" }}>
                  Team
                </div>
              </div>
            </div>
            <p style={{ color: "#aaa", fontSize: "0.9rem", lineHeight: 1.6, fontWeight: 500 }}>
              {t("footerDesc")}
            </p>
          </div>

          {/* Col 2 — Navigation */}
          <div>
            <h3 style={{
              color: "#f5c200",
              fontWeight: 800,
              fontSize: "0.78rem",
              textTransform: "uppercase",
              letterSpacing: "0.14em",
              marginBottom: 16,
            }}>
              {t("navigation")}
            </h3>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} style={{
                    color: "#ccc",
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    textDecoration: "none",
                    transition: "color 0.15s",
                  }}
                  className="hover:text-white transition">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Contact */}
          <div>
            <h3 style={{
              color: "#f5c200",
              fontWeight: 800,
              fontSize: "0.78rem",
              textTransform: "uppercase",
              letterSpacing: "0.14em",
              marginBottom: 16,
            }}>
              {t("contact")}
            </h3>
            <ul className="space-y-3">
              {[
                "contact@startingfive.tg",
                "+228 90 47 87 25",
                "Cité Mokpokpo,\nAdidogomé Lomé, Togo",
              ].map((item, i) => (
                <li key={i} style={{ color: "#ccc", fontSize: "0.95rem", fontWeight: 500, whiteSpace: "pre-line" }}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Ligne légale */}
        <div style={{
          borderTop: "1px solid #2a2a2a",
          padding: "16px 24px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "8px 24px",
        }}>
          {legalLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              style={{
                color: "#555",
                fontSize: "0.82rem",
                textDecoration: "none",
                transition: "color 0.15s",
              }}
              className="hover:text-gray-300 transition"
            >
              {l.label}
            </Link>
          ))}
        </div>

        {/* Ligne de copyright */}
        <div style={{ borderTop: "1px solid #222", padding: "12px 24px", textAlign: "center" }}>
          <span style={{ color: "#444", fontSize: "0.82rem" }}>
            {t("copyright")}
          </span>
        </div>
      </div>
    </footer>
  );
}